var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.934,
    height: 89.934,
    viewBox: "0 0 89.934 89.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sound-icon",
    transform: "translate(-924.601 -2891.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34402",
    "data-name": "Path 34402",
    d: "M44.967,0A44.967,44.967,0,1,1,0,44.967,44.967,44.967,0,0,1,44.967,0Z",
    transform: "translate(924.601 2891.194)",
    fill: "#ce202e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27502",
    "data-name": "Path 27502",
    d: "M944.05,2942.537v-12.76a4.785,4.785,0,0,1,4.785-4.785h6.38l10.885-10.5a1.985,1.985,0,0,1,3.469,1.331v40.671a1.986,1.986,0,0,1-3.469,1.332l-10.885-10.5h-6.38a4.784,4.784,0,0,1-4.785-4.784Zm34.618,2.551a12.759,12.759,0,0,0,0-17.863,1.595,1.595,0,0,0-2.719,1.069v15.726a1.594,1.594,0,0,0,2.719,1.068Zm1.754,14.139a25.479,25.479,0,0,0,0-46.133,3.19,3.19,0,0,0-2.655,5.774,19.139,19.139,0,0,1,0,34.586,3.189,3.189,0,0,0,2.655,5.773Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIcon);
export default __webpack_public_path__ + "static/media/sound-icon.ffdb36da4693ffd37cc6f1318a0a5f5a.svg";
export { ForwardRef as ReactComponent };